import { connect } from 'unistore/preact';
import { CACHE } from '../../utils/constants';

const EmiBankList = props => {
  const emiBankDetails = props.cache.getData(CACHE.EMI_BANK_LIST);
  return (
    <div className={`ptm-emi-dropdown-wrap`}>
      <div className={`ptm-close-wrap ptm-pos-a`} onClick={props.hideBankList}>
        <span className={`ptm-cross ptm-pos-r`} />
      </div>
      {/* selection of bank */}
      <div className={`ptm-emi-bankcard-wrapper ptm-pos-r`}>
        {emiBankDetails &&
          emiBankDetails.map(emiTypeBanks => (
            <div className={`ptm-emi-type-block`}>
              <h3 class="ptm-body-bg ptm-body-color">{emiTypeBanks.displayLabel}</h3>
              {emiTypeBanks.cardTypes.map(card => {
                return (
                  <div
                    className={`ptm-emi-bankcard ptm-pos-r nb-border`}
                    onClick={() => {
                      props.closeBankList(card);
                    }}
                  >
                    <div className={`ptm-emi-cardimg ptm-pos-a ptm-global-border`}>
                      <img
                        className={`ptm-margin0 ptm-centralized ptm-pos-a`}
                        src={card.bankLogoUrl}
                        alt={card.bankCode}
                      />
                    </div>
                    <span className={`ptm-body-color ${card.isDisabled ? 'ptm-disabledCard' : ''}`}>
                      {/* for standard emi plans need to show card label type along with bank (cc/dc)
                      if display name is set show that else show bank name as usual for (emi subvention) */}
                      {card.displayName ? card.displayName : card.bankName}
                    </span>
                    {card.isDisabled && (
                      <p className={`ptm-low-success`}>Emi option is not available</p>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
      </div>
    </div>
  );
};

export default connect('cache')(EmiBankList);



// WEBPACK FOOTER //
// ./components/emiBankList/index.js